import { publicRouteUrl, spacePublicHost } from "../../shared/publicUrl";
import { config } from "../environment";
import type { PublicDomain } from "../hooks/derivePublicDomain";
import type { ParsedStep } from "./parseCommitData";

export function getStepCopyableUrl(
  step: ParsedStep,
  branchId: string,
  isOnMainBranch: boolean,
  spaceSlug: string,
  externalPublicUrl: string,
  publicDomain: PublicDomain,
  customDomain?: string | null
): string | null {
  if (!step.publicRoute) return null;
  return getPageUrl(
    spaceSlug,
    step.publicRoute,
    externalPublicUrl,
    publicDomain,
    {
      branchId: isOnMainBranch ? null : branchId,
      externalId: step.routeExternalId,
    },
    customDomain
  );
}

export function truncateMiddle(url: string, maxLength: number): string {
  const display = url.replace(/^https?:\/\//, "");
  if (display.length <= maxLength) return display;
  const keep = maxLength - 1;
  const start = Math.ceil(keep / 2);
  const end = Math.floor(keep / 2);
  return `${display.slice(0, start)}…${display.slice(-end)}`;
}

export function getStepCopyableEmailAddress(
  step: ParsedStep,
  branchId: string,
  isOnMainBranch: boolean,
  spaceSlug: string,
  publicDomain: PublicDomain
): string | null {
  if (!step.emailAddress) return null;
  const { inboundEmailDomain, selfHostedSingleTenant } = config;
  // A single stack-wide inbound domain can't identify a tenant, so tenant-scope
  // email addresses are a single-tenant feature.
  const host = publicDomain.wildcardDomain
    ? spacePublicHost(
        spaceSlug,
        publicDomain.wildcardDomain,
        publicDomain.combinedSpaceTenantLabel
      )
    : selfHostedSingleTenant
      ? inboundEmailDomain
      : undefined;
  if (!host) return null;
  const local = isOnMainBranch
    ? step.emailAddress
    : `${step.emailAddress}+${branchId}`;
  return `${local}@${host}`;
}

export function getPageUrl(
  spaceSlug: string,
  route: string,
  externalPublicUrl: string,
  publicDomain: PublicDomain,
  params?: { branchId?: string | null; externalId?: string | null },
  customDomain?: string | null
): string {
  return publicRouteUrl(
    spaceSlug,
    route,
    {
      publicUrl: externalPublicUrl,
      publicWildcardDomain: publicDomain.wildcardDomain,
      combinedSpaceTenantLabel: publicDomain.combinedSpaceTenantLabel,
      customDomain,
    },
    params
  );
}
